import {Checkbox as UICheckbox} from "@headlessui/react";
import clsx from "clsx";

export interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({checked, onChange}) => {
  return (
    <UICheckbox
      checked={checked}
      onChange={onChange}
      className={clsx(
        "flex items-center justify-center space-x-2 cursor-pointer w-5 h-5 aspect-square border border-gray-300 rounded-sm focus:outline-none",
        checked ? "bg-primary" : "",
      )}
    >
      {checked && (
        <svg
          className={clsx("w-3 h-3 text-background", checked ? "bg-primary" : "")}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
      )}
    </UICheckbox>
  );
};
